import React from 'react';
import { Route } from 'react-router-dom';
import _ from 'lodash';
import dollarsToCents from 'dollars-to-cents';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from 'app/routes/history';
import HeaderThin from 'app/components/layout/HeaderThin';
import ProgressIndicator, { IStep } from 'app/components/general/ProgressIndicator';

import * as paymentActions from 'app/ducks/payments/actions';
import * as paymentRequestActions from 'app/ducks/paymentRequests/actions';
import * as personActions from 'app/ducks/people/actions';
import * as groupActions from 'app/ducks/groups/actions';
import * as organisationTagActions from 'app/ducks/organisationTags/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentRequestsSelectors from 'app/ducks/paymentRequests/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as peopleSelectors from 'app/ducks/people/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';
import * as organisationTagsSelectors from 'app/ducks/organisationTags/selectors';

import Step1PaymentDetail from './Step1PaymentDetail';
import Step2SelectPeople from './Step2SelectPeople';
import Step3SendNotifications from './Step3SendNotifications';
import Step4Confirm from './Step4Confirm';

interface INewPaymentRequestProps {
  backendErrors?: any;
  actions?: any;
  match?: any;
  organisations?: any;
  paymentRequests?: any;
  organisationTags?: any;
  people?: any;
  groups?: any;
  appReady?: boolean;
}

interface INewPaymentRequestState {
  // initialFilter: any;
  error?: string;
  state: {
    paymentType: string;
    description: string;
    amount: string;
    dueDate: string;
    sendEmailNotification: boolean;
    sendSMSNotification: boolean;
    sendEmailReminders: boolean;
    sendSMSReminders: boolean;
  };
  payeeType: string;
  selectedPeopleIds: string[];
  selectedPeopleById: any;
  selectedAllRows: boolean;
  selectedRowIds: string[];
  selectedRows: any;
  // errors: any;
  // changed: boolean;
  // saved: boolean;
  originalFormData: {
    paymentType: string;
    description: string;
    amount: string;
    dueDate: string;
  };
  formData: any;
  changed: boolean;
  saved: boolean;
  errors: any;
}

function selector(state): any {
  return {
    paymentRequests: paymentRequestsSelectors.getPaymentRequests(state),
    organisations: organisationsSelectors.getOrganisations(state),
    people: peopleSelectors.getPeople(state),
    groups: groupsSelectors.getGroups(state),
    organisationTags: organisationTagsSelectors.getTags(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  paymentActions,
  paymentRequestActions,
  personActions,
  groupActions,
  organisationTagActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class NewPaymentRequest extends React.Component<INewPaymentRequestProps, INewPaymentRequestState> {
  static defaultProps: INewPaymentRequestProps = {
    match: undefined,
    backendErrors: undefined,
    actions: undefined,
    organisations: undefined,
    organisationTags: undefined,
    people: undefined,
    groups: undefined,
    organisatonTags: undefined,
    appReady: false,
  };

  state: INewPaymentRequestState = {
    formData: {
      paymentType: undefined,
      description: undefined,
      amount: undefined,
      dueDate: undefined,
    },
    originalFormData: {
      paymentType: undefined,
      description: undefined,
      amount: undefined,
      dueDate: undefined,
    },
    payeeType: 'individuals',
    selectedRows: {},
    selectedAllRows: false,
    selectedRowIds: [],
    selectedRowsById: {},
    errors: {},
    changed: false,
    saved: false,
    initialFilter: undefined,

  };

  componentDidMount(): void {
    if (
      this.props.appReady
    ) {
      this.props.actions.getAllPeople();
      this.props.actions.getAllOrganisationTags();
      this.props.actions.getAllGroups();
    }
  }

  isValid = (): boolean => _.isEmpty(this.state.errors);

  handleChange = (e): void => {
    const changed = this.state.originalFormData !== e.formData;
    // console.log(e);

    this.setState(() => ({
      formData: e.formData,
      errors: [],
      changed,
    }));
  };

  handleError = (errors): void => {
    this.setState({ errors });
  }

  handleChangePayeeType = (e): void => {
    this.setState(() => ({
      payeeType: e,
    }));
  };

  updateSelectedRows = (prevState, selectedRows): any => {
    // console.log(prevState);
    // console.log(selectedRows);
    const selectedRowIds = _.keys(_.pickBy(selectedRows, (d) => d));

    return {
      ...prevState,
      selectedRowIds,
      selectedRows,
    };
  }

  selectRow = (id): void => {
    this.setState((prevState) => {
      const selectedRows = {
        ...prevState.selectedRows,
        [id]: !prevState.selectedRows[id],
      };
      return this.updateSelectedRows(prevState, selectedRows);
    });
  };

  selectAllRows = (rows): void => {
    this.setState((prevState) => {
      const selectedRows = {};
      const selectionValue = !prevState.selectedAllRows;

      _.map(rows, (row) => {
        selectedRows[row.id] = selectionValue;
      });
      return this.updateSelectedRows({ ...prevState, selectedAllRows: !prevState.selectedAllRows }, selectedRows);
    });
  };

  removeRow = (id): void => {
    this.setState((prevState) => {
      const selectedRows = {
        ...prevState.selectedRows,
        [id]: false,
      };

      return this.updateSelectedRows(prevState, selectedRows);
    });
  };

  removeAllRows = (rows): void => {
    this.setState((prevState) => {
      const selectedRows = {};

      _.map(rows, (row) => {
        selectedRows[row.id] = false;
      });

      return this.updateSelectedRows(prevState, selectedRows);
    });
  };

  handleDetailNext = (e): void => {
    this.setState({ changed: false });
    history.push('/payments/segments/requests/new/select');
  }

  handleSubmit = (e): void => {
    e.preventDefault();
    if (this.isValid()) {
      let payload: any = {
        metadataCategory: this.state.formData.paymentType.id,
        description: this.state.formData.description,
        amount: dollarsToCents(this.state.formData.amount),
        dueAt: this.state.formData.dueDate[0],
        organisation: { id: this.props.organisations.currentOrganisation.id },
      };
      if (this.state.payeeType === 'individuals') {
        const personIds = _.map(this.state.selectedRowIds, (o) => ({ id: o }));
        // sendSmsReminder1OrgCustomers: { scheduled: this.state.formData.sendSMSReminders, timeframe: '1 day' },
        // sendEmailReminder1OrgCustomers: { scheduled: this.state.formData.sendEmailReminders, timeframe: '1 day' },

        payload = {
          ...payload,
          paymentType: 'organisation',
          paymentCategory: 'individual-request',
          people: personIds,
          notificationConfiguration: {
            sendSmsInitialNotificationOrgCustomers: { scheduled: this.state.formData.sendSMSNotification, timeframe: '1 day' },
            sendEmailInitialNotificationOrgCustomers: { scheduled: this.state.formData.sendEmailNotification, timeframe: '1 day' },
            sendSmsDueReminderOrgCustomers: { scheduled: this.state.formData.sendSMSReminders, timeframe: '0 days' },
            sendEmailDueReminderOrgCustomers: { scheduled: this.state.formData.sendEmailReminders, timeframe: '0 days' },
          },
        };
      } else if (this.state.payeeType === 'teams') {
        const groupIds = _.map(this.state.selectedRowIds, (o) => ({ id: o }));
        // sendSmsReminder1OrgTeams: { scheduled: this.state.formData.sendSMSReminders, timeframe: '1 day' },
        // sendEmailReminder1OrgTeams: { scheduled: this.state.formData.sendEmailReminders, timeframe: '1 day' },

        payload = {
          ...payload,
          paymentType: 'organisation',
          paymentCategory: 'team-request',
          groups: groupIds,
          notificationConfiguration: {
            sendSmsInitialNotificationOrgTeams: { scheduled: this.state.formData.sendSMSNotification, timeframe: null },
            sendEmailInitialNotificationOrgTeams: { scheduled: this.state.formData.sendEmailNotification, timeframe: null },
            sendSmsDueReminderOrgTeams: { scheduled: this.state.formData.sendSMSReminders, timeframe: '0 days' },
            sendEmailDueReminderOrgTeams: { scheduled: this.state.formData.sendEmailReminders, timeframe: '0 days' },
          },
        };
      }
      this.props.actions.createPayment(payload);
    }
  };

  render(): React.ReactNode {
    const steps: IStep[] = [
      {
        number: 1,
        text: 'Payment Details',
        complete: this.props.match.url !== '/payments/segments/requests/new',
        active: this.props.match.url === '/payments/segments/requests/new',
      },
      {
        number: 2,
        text: 'Select Payee/s',
        complete: _.includes(['/payments/segments/requests/new/confirm', '/payments/segments/requests/new/notifications'], this.props.match.url),
        active: this.props.match.url === '/payments/segments/requests/new/select',
      },
      {
        number: 3,
        text: 'Notifications',
        complete: _.includes(['/payments/segments/requests/new/confirm'], this.props.match.url),
        active: this.props.match.url === '/payments/segments/requests/new/notifications',
      },
      {
        number: 4,
        text: 'Confirm',
        complete: false,
        active: this.props.match.url === '/payments/segments/requests/new/confirm',
      },
    ];

    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="New Payment Request"
              breadcrumb="Payments"
              breadcrumbLink="/payments/segments/requests"
            />
          </div>
        </div>
        {/* <div className="row">
          <div className="col col-12 col-lg-10 col-xl-8">
            <ProgressIndicator steps={steps} />
          </div>
        </div> */}

        <Route
          exact
          path="/payments/segments/requests/new"
          render={() => (
            <div className="row">
              <div className="col col-12 col-lg-10 col-xl-8">
                <Step1PaymentDetail
                  isValid={this.isValid}
                  handleChange={this.handleChange}
                  handleError={this.handleError}
                  handleSubmit={this.handleDetailNext}
                  formData={this.state.formData}
                  errors={this.props.paymentRequests.backendErrors}
                  changed={this.state.changed}
                  paymentRequests={this.props.paymentRequests}
                  originalFormData={this.state.originalFormData}
                >
                  <ProgressIndicator steps={steps} />
                </Step1PaymentDetail>
              </div>
            </div>
          )}
        />

        <Route
          exact
          path="/payments/segments/requests/new/select"
          render={() => (
            <div className="row">
              <div className="col col-12">
                <Step2SelectPeople
                  updateSelectedRows={this.updateSelectedRows}
                  handleChangePayeeType={this.handleChangePayeeType}
                  actions={this.props.actions}
                  appReady={this.props.appReady}
                  people={this.props.people}
                  groups={this.props.groups}
                  organisationTags={this.props.organisationTags}
                  selectRow={this.selectRow}
                  selectedRows={this.state.selectedRows}
                  selectedRowIds={this.state.selectedRowIds}
                  selectedAllRows={this.state.selectedAllRows}
                  selectAllRows={this.selectAllRows}
                  removeRow={this.removeRow}
                  removeAllRows={this.removeAllRows}
                >
                  <ProgressIndicator steps={steps} />
                </Step2SelectPeople>
              </div>
            </div>
          )}
        />
        <Route
          exact
          path="/payments/segments/requests/new/notifications"
          render={() => (
            <div className="row with-margin-top-20">
              <div className="col col-12 col-lg-10 col-xl-8">
                <Step3SendNotifications
                  actions={this.props.actions}
                  appReady={this.props.appReady}
                  isValid={this.isValid}
                  handleChange={this.handleChange}
                  handleError={this.handleError}
                  formData={this.state.formData}
                  errors={this.props.paymentRequests.backendErrors}
                  changed={this.state.changed}
                  paymentRequests={this.props.paymentRequests}
                  originalFormData={this.state.originalFormData}
                >
                  <ProgressIndicator steps={steps} />
                </Step3SendNotifications>
              </div>
            </div>

          )}
        />
        <Route
          exact
          path="/payments/segments/requests/new/confirm"
          render={() => (
            <div className="row with-margin-top-20">
              <div className="col col-12 col-lg-10 col-xl-8">
                <Step4Confirm
                  actions={this.props.actions}
                  appReady={this.props.appReady}
                  isValid={this.isValid}
                  handleChange={this.handleChange}
                  handleSubmit={this.handleSubmit}
                  formData={this.state.formData}
                  payeeType={this.state.payeeType}
                  errors={this.props.paymentRequests.backendErrors}
                  selectedRowIds={this.state.selectedRowIds}
                  changed={this.state.changed}
                  paymentRequests={this.props.paymentRequests}
                  originalFormData={this.state.originalFormData}
                >
                  <ProgressIndicator steps={steps} />
                </Step4Confirm>
              </div>
            </div>

          )}
        />
      </div>
    );
  }
}
